import React, {
  Suspense,
  useRef,
  useEffect,
  useContext,
  Fragment,
  useState,
  useImperativeHandle,
  lazy,
  forwardRef,
} from "react";
//import { useLocation } from "react-router-dom";
import {
  Container,
  Grid,
  Hidden,
  Tooltip,
  Fab,
  Grow,
  useMediaQuery,
  ClickAwayListener,
} from "@material-ui/core";
import { withStyles, useTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";

import SongFavorite from "./SongFavorite";
//import ArtistRating from "./ArtistRating";

const ArtistRating = lazy(() =>
  import(/* webpackChunkName: "artstrtng" */ "./ArtistRating")
);

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//const AudioPlayer = lazy(() =>
//  import(/* webpackChunkName: "adio" */ "../../player/audio_player.js.jsx")
//);

import AudioPlayer from "../../player/audio_player.js.jsx";
const FreakingOutOverlay = lazy(() =>
  import(
    /* webpackChunkName: "frkn" */ "../../misc/freaking_out_overlay.js.jsx"
  )
);
const AutoplayOverlay = lazy(() =>
  import(
    /* webpackChunkName: "autoplayovrly" */ "../../player/autoplay_overlay.js.jsx"
  )
);
const LandingArtistNotFound = lazy(() =>
  import(
    /* webpackChunkName: "landingartnotfnd" */ "../../player/landing_artist_not_found.js.jsx"
  )
);
const TooManySkipsMessage = lazy(() =>
  import(/* webpackChunkName: "toomskps" */ "./TooManySkipsMessage")
);
const VolumeSlider = lazy(() =>
  import(/* webpackChunkName: "vlmsdr" */ "./VolumeSlider")
);
const TuneInMessage = lazy(() =>
  import(/* webpackChunkName: "timssg" */ "./TuneInMessage")
);
const FaveMessage = lazy(() =>
  import(/* webpackChunkName: "fvmssg" */ "./FaveMessage")
);
const Intro = lazy(() => import(/* webpackChunkName: "intro" */ "./Intro"));
import { usd } from "lib/player_util.js";
import PlayerCtrlsBackButton from "../../player/player_ctrls_back_button.js.jsx";

import LoadingSection from "./LoadingSection";

import { observer } from "mobx-react-lite";
import { playerStoreContext } from "lib/player_store";

import SongTimer from "../../player/song_timer.js";

const HtmlTooltip = withStyles((_theme) => ({
  arrow: { color: "#ffd800" },
  tooltip: {
    backgroundColor: "#ffd800", // dark blue"#13598b",
    color: "#000",
    cursor: "pointer",
    // maxWidth: 220,
    //  fontSize: theme.typography.pxToRem(12),
    //border: "1px solid #dadde9",
  },
}))(Tooltip);

const BouncingBars = ({ paused, song, onMouseEnter }) => {
  const setRandomAnimationDuration = (e) => {
    //  console.log(e);
    e.style.animationDuration = Math.random() * (2.9 - 2.0) + 2.0 + "s";
  };

  useEffect(() => {
    const bars = document.querySelectorAll("#bouncing-bars .bar");

    bars.forEach((bar) => {
      //bar.addEventListener("animationiteration", setRandomAnimationDuration);
      setRandomAnimationDuration(bar);
    });
  }, [song]);

  return (
    <svg
      onMouseEnter={onMouseEnter}
      xmlns="http://www.w3.org/2000/svg"
      id="bouncing-bars"
      className={paused ? "out" : null}
      viewBox="0 0 128 128"
    >
      <g>
        <rect className="bar" transform="translate(5,0)" y="15"></rect>
        <rect className="bar" transform="translate(20,0)" y="15"></rect>
        <rect className="bar" transform="translate(35,0)" y="15"></rect>
        <rect className="bar" transform="translate(50,0)" y="15"></rect>
        <rect className="bar" transform="translate(65,0)" y="15"></rect>
        <rect className="bar" transform="translate(80,0)" y="15"></rect>
        <rect className="bar" transform="translate(95,0)" y="15"></rect>
      </g>
    </svg>
  );
};

const COUNTDOWN_SECS = 6;

const Resumer = () => {
  const store = useContext(playerStoreContext);
  const [checked, setChecked] = useState(true);
  const [countdown, setCountdown] = useState(COUNTDOWN_SECS);

  useEffect(() => {
    if (countdown <= 1) {
      setChecked(false);
    }
    if (countdown <= 0) {
      store.setPaused(false);
    } else {
      setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    }
  }, [countdown]);

  const setCountDownZero = () => {
    setCountdown(0);
  };

  const setResumingFalse = () => {
    store.setResuming(false);
  };

  return (
    <div id="resumer">
      <Grow in={checked}>
        <Fab className="resume" variant="extended" onClick={setCountDownZero}>
          <FontAwesomeIcon icon="play-circle" size="2x" />
          Resuming <div className="pill">{countdown}</div>
        </Fab>
      </Grow>
      <Grow
        in={checked}
        style={{ transformOrigin: "0 0 0" }}
        {...(checked ? { timeout: 1000 } : {})}
      >
        <Fab className="cancel" variant="extended" onClick={setResumingFalse}>
          <FontAwesomeIcon icon="pause-circle" size="2x" />
          Cancel
        </Fab>
      </Grow>
    </div>
  );
};

const Player = (props, ref) => {
  useImperativeHandle(ref, () => ({
    skip: skip,
  }));

  const theme = useTheme();
  const smallOrSmaller = useMediaQuery(theme.breakpoints.down("sm"));

  const store = useContext(playerStoreContext);
  //const { pathname } = useLocation();
  const {
    songInfo: {
      url,
      station_id,
      station_name,
      song,
      music_path,
      artist,
      //  artist_id,
      band_id,
      //  has_radio,
      song_id,
      favorite,
      video_id,
      video_link,
      monetized,
      //  session_plays,

      //   spc,
      //   station_type,
      //   stype,
    },
    paused,
    user_id,
    freakingOut,
    firstTime,
    airplayThumbsOpen,
    loading,
    autoplayOverlayVariant,
    autoplayOverlay,
    resuming,
    not_found_artist_name,
    station_error,
    tooManySkipsMessageOpen,
    snackCopy,
    faveSnackOpen,
    _youtubeID,
  } = store;

  const audioPlayerRef = useRef(null);

  const freakingOutClick = () => {
    store.setFreakingOut(false);
  };

  const autoplayOverlayClick = (_e, _reason) => {
    store.set_autoplayOverlay("closed");

    try {
      window.gtag("event", "click", {
        event_category: "player",
        event_label: "autoplay_warning",
      });
    } catch (e) {
      console.log("ga error: ", "autoplay_warning", e);
    }
  };

  const handleRewindClick = (e) => {
    e.preventDefault();

    if (video_id) {
      store.setYoutubeID(video_id);
    } else {
      store.setSnackCopy("No video found for this song.");
    }
    return false;
  };

  const landingArtistNotFoundClick = (event) => {
    event?.stopPropagation();
    event?.preventDefault();

    try {
      window.gtag("event", "click", {
        event_category: "player",
        event_label: "artist_not_found",
      });
    } catch (e) {
      console.log("ga error: ", "artist_not_found", e);
    }
    store.null_not_found_artist_name();

    if (autoplayOverlay == "trigger") {
      store.set_autoplayOverlay("closed");
      store.setResuming(true);
    }
  };

  // const setSongTime = (newTime) => {
  //   store.set_songTime(newTime);
  // };

  const skip = (e) => {
    e?.preventDefault();

    store.handleSkipSong();

    _jm.next = false;
    _jm.skipped = true;
    _jm.clicked = e ? true : false;
    _jm.offset = audioPlayerRef.current.getSeek();

    //ctrls.onSkip(true);

    try {
      audioPlayerRef.current.stop();
    } catch (e) {
      console.log("player ctrls STOP", e);
    }

    usd();

    if (band_id) {
      if (monetized) {
        try {
          window.gtag("event", "skip", {
            event_category: "audio",
            event_label: "monetized",
          });
        } catch (e) {}
      } else {
        try {
          window.gtag("event", "skip", {
            event_category: "audio",
            event_label: "organic",
          });
        } catch (e) {}
      }
    } else {
      try {
        window.gtag("event", "skip", {
          event_category: "audio",
          event_label: "established",
        });
      } catch (e) {}
    }
  };

  const play_pause = (e) => {
    e?.preventDefault();
    console.log("onplaypause");
    // needed ?
    if (e) {
      _jm.player_wait = false;
    }

    if (store.paused && autoplayOverlay == "trigger") {
      store.set_autoplayOverlay("closed");
    }

    store.manage_pause();

    // try {
    //   window._videoPlayer.pauseVideo();
    // } catch (e) {}
  };

  useEffect(() => {
    // get rid of this
    // window.PlayerUI = this;

    // get song url only to trigger play log
    //console.log("player MOUNT"); //, this.store.songInfo.song);
    // if page tunes into a station, get url_only stream
    // otherwise let the user click tune in
    if (firstTime && song && !url) {
      usd(true);
    } else {
      store.set_loading(false);
    } // handle no stream

    // testAutoplay();
  }, []);

  const unsetSnackCopy = () => {
    store.setSnackCopy(null);
  };
  const unsetFaveSnackOpen = () => {
    store.setFaveSnackOpen(null);
  };

  // const testAutoplay = () => {
  //   console.log("player test autoplay")
  //   song && x?.current?.testAutoplay();
  // };

  //const classes = useStyles();
  // if (!song) {
  //   return (
  //     <div>
  //       <div id="player-spacer"></div>
  //       <div id="player"></div>
  //     </div>
  //   );
  // }

  useEffect(() => {
    setPlayTooltipOpen(
      smallOrSmaller &&
        song &&
        paused &&
        !Boolean(not_found_artist_name) &&
        autoplayOverlay === "trigger"
    );
  }, [smallOrSmaller, song, not_found_artist_name, autoplayOverlay, paused]);

  const [playTooltipOpen, setPlayTooltipOpen] = useState(
    smallOrSmaller &&
      song &&
      !Boolean(not_found_artist_name) &&
      autoplayOverlay === "trigger"
  );

  const handlePlayTooltipClose = () => {
    console.log("tooltip close");

    setPlayTooltipOpen(false);
  };

  const handlePlayTooltipOpen = () => {
    setPlayTooltipOpen(true);
  };

  const playTooltipClick = (e) => {
    if (autoplayOverlay !== "trigger" || !playTooltipOpen) {
      console.log("tooltip click false");

      return false;
    } else {
      console.log("tooltip click");
    }
    if (!window.Howler._howls[0].playing()) {
      window.Howler._howls[0].play();
    }

    autoplayOverlayClick(e);
  };

  const closeAutoPlayOverlay = () => {
    store.closeAirplayOverlay();
  };

  const faveMessage = ({ isFavorite, _song_id }) => {
    if (isFavorite) {
      store.setFaveSnackOpen(true);
    }
  };

  return (
    <div>
      <AudioPlayer ref={audioPlayerRef} />
      <div id="player-spacer"></div>
      <div id="player">
        {/* loading && <LoadingSection type="loading-player" /> */}
        {!loading && song && (
          <Container>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              style={{ height: "3.9em" }}
            >
              <Hidden smDown>
                <Grid item md={3} className="pr-4 pt-1" id="player-radio">
                  <Grid container justifyContent="flex-end" alignItems="center">
                    <Hidden mdDown>
                      <Grid item>
                        <BouncingBars paused={paused} song={song} />
                      </Grid>
                    </Hidden>
                    <Grid item id="player-station-name">
                      <Tooltip title={station_name}>
                        <Link to={`/stations/${station_id}`}>
                          {station_name}
                        </Link>
                      </Tooltip>
                    </Grid>
                    <Grid item id="player-volume">
                      <Suspense fallback={null}>
                        <VolumeSlider />
                      </Suspense>
                    </Grid>
                  </Grid>
                </Grid>
              </Hidden>
              <Grid item xs={12} md={6}>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  id="player-ctrls"
                >
                  {resuming && <Resumer />}

                  <Grid item style={{ cursor: "pointer" }}>
                    <PlayerCtrlsBackButton
                      video_id={video_id}
                      onClick={handleRewindClick}
                    />
                  </Grid>
                  <Grid item className="pl-5 pl-md-4 pr-5 pr-md-4">
                    <HtmlTooltip
                      open={playTooltipOpen}
                      onClose={handlePlayTooltipClose}
                      onOpen={handlePlayTooltipOpen}
                      placement="top"
                      arrow
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      interactive={true}
                      title={
                        <ClickAwayListener onClickAway={playTooltipClick}>
                          <Grid
                            onClick={playTooltipClick}
                            container
                            alignItems="center"
                            justifyContent="center"
                            style={{ width: "100%", textAlign: "center" }}
                          >
                            <Grid item xs={12}>
                              <FontAwesomeIcon
                                icon="play-circle"
                                style={{ fontSize: "6rem" }}
                                className="mt-3"
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <h3>Play</h3>
                              <h1 className="mt-3">{artist}</h1>
                            </Grid>
                          </Grid>
                        </ClickAwayListener>
                      }
                    >
                      <div
                        id="player-play-button"
                        onClick={play_pause}
                        aria-label={paused ? "Click to Play" : "Click to Pause"}
                      >
                        <FontAwesomeIcon
                          icon={paused ? "play-circle" : "pause-circle"}
                        />
                      </div>
                    </HtmlTooltip>
                  </Grid>
                  <Grid
                    item
                    style={{ cursor: "pointer" }}
                    onClick={skip}
                    aria-label="Click to Skip to Next Song"
                  >
                    <FontAwesomeIcon
                      style={{ margin: "0.5rem 1rem" }}
                      icon="step-forward"
                      className="icon-action"
                    />
                  </Grid>
                </Grid>
                <SongTimer />
              </Grid>
              <Hidden smDown>
                <Grid item md={3} className="pl-4">
                  <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    id="player-artist-song"
                  >
                    <Grid item id="player-favorite">
                      <SongFavorite
                        song_id={song_id}
                        favorite={favorite}
                        callback={faveMessage}
                      />
                    </Grid>
                    <Grid item md>
                      <div id="player-song-title">
                        {video_link ? (
                          <Link to={video_link}>{song}</Link>
                        ) : (
                          <Fragment>{song}</Fragment>
                        )}
                      </div>

                      <div id="player-artist">
                        <Link to={music_path}>{artist}</Link>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Hidden>
            </Grid>
          </Container>
        )}
      </div>
      <Suspense fallback={null}>
        {song && band_id && (
          <ArtistRating show={airplayThumbsOpen} close={closeAutoPlayOverlay} />
        )}
      </Suspense>
      {freakingOut && (
        <Suspense fallback={null}>
          <FreakingOutOverlay
            freakingOut={freakingOut}
            freakingOutClick={freakingOutClick}
            skip={skip}
            // browseStations={browseStations}
            // nav={nav}
          />
        </Suspense>
      )}
      <Suspense fallback={null}>
        {!smallOrSmaller &&
          song &&
          !Boolean(not_found_artist_name) &&
          autoplayOverlay === "trigger" && (
            <AutoplayOverlay
              variant={autoplayOverlayVariant}
              open={autoplayOverlay === "trigger"}
              artist={artist}
              clickHandler={autoplayOverlayClick}
            />
          )}
      </Suspense>
      <Suspense fallback={null}>
        {(Boolean(not_found_artist_name) || Boolean(station_error)) && (
          <LandingArtistNotFound
            artist={not_found_artist_name}
            open={Boolean(not_found_artist_name) || Boolean(station_error)}
            clickHandler={landingArtistNotFoundClick}
          />
        )}
      </Suspense>
      <Suspense fallback={null}>
        {tooManySkipsMessageOpen && (
          <TooManySkipsMessage open={tooManySkipsMessageOpen} />
        )}
      </Suspense>
      <Suspense fallback={null}>
        {Boolean(snackCopy) && (
          <TuneInMessage
            open={Boolean(snackCopy)}
            setOpen={unsetSnackCopy}
            copy={snackCopy}
          />
        )}
      </Suspense>
      <Suspense fallback={null}>
        {faveSnackOpen && (
          <FaveMessage
            open={Boolean(faveSnackOpen)}
            setOpen={unsetFaveSnackOpen}
            song={song}
            song_id={song_id}
            user_id={user_id}
          />
        )}
      </Suspense>
      <Suspense fallback={null}>
        {song && autoplayOverlay !== "trigger" && <Intro />}
      </Suspense>
    </div>
  );
};

export default observer(forwardRef(Player));
